<template>
  <div class="view view_softwareexpired">
    <h1>{{ $t("softwareExpired.heading") }}</h1>
    <i18n-t keypath="softwareExpired.contactEmail" tag="p" scope="global">
      <a href="mailto:hello@simcision.com">hello@simcision.com</a>.
    </i18n-t>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.view_softwareexpired {
  padding: 3rem;
  background-color: var(--color-action);
  color: var(--color-action-contrast);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  a {
    color: var(--color-action-contrast);
  }
}
</style>
